import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { parseDate } from "../../helpers/moment"

const query = graphql`
    query {
        pageText {
            date {
                begin
                early_bird
                end
            }
        }
    }
`

export const DateMd = ({ name, format }) => {
    const data = useStaticQuery(query);
    const dates = data.pageText.date;

    if(!(name in dates)) {
        console.log(`The date ${name} does not exist`);
        return null;
    }

    const date = parseDate(dates[name])

    return <span>{date.format(format)}</span>
}